<template>
  <div class="chatPanel dark-3">
    <!--    头部-->
    <div class="header">
      <div v-if="screenWidth<=768" class="header-sLeft">
        <img class="header-folder" @click="clickFolder" :src="`${$g.imgPrefix}/img/shareAI/folder-light.svg`" alt="">
        <div class="quota">
          <el-popover
              popper-class="quota-popper"
              :visible-arrow="false"
              placement="bottom-start"
              width="260"
              trigger="click">
            <div class="body">
              <div class="quota-popper-title white">Your Plan</div>
              <div class="info">
                <!-- Free quota：-->
                <div class="info-item">
                  <div class="info-item-label light-color-3">Free quota：</div>
                  <div class="info-item-count white">
                    <span class="info-item-value before">{{ quotaData.usedFreeCount }}</span>
                    /
                    <span class="info-item-value">{{ quotaData.freeTokenLimit }}</span>
                  </div>
                </div>
                <!-- Paid quota：-->
                <div class="info-item">
                  <div class="info-item-label light-color-3">Paid quota：</div>
                  <div class="info-item-paid-count white">
                    <span>{{ quotaData.paidQuota }}</span>
<!--                    <el-popover-->
<!--                        popper-class="paid-popper"-->
<!--                        placement="top"-->
<!--                        width="160"-->
<!--                        trigger="click">-->
<!--                      <div class="list light-color-3">-->
<!--                        <div class="item">-->
<!--                          <div class="label">Subscription quotas</div>-->
<!--                          <div class="count">{{ paidQuota.subscription }}</div>-->
<!--                        </div>-->
<!--                        <div class="item">-->
<!--                          <div class="label">Extra quotas</div>-->
<!--                          <div class="count">{{ paidQuota.extra }}</div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <i slot="reference" class="el-icon-warning"></i>-->
<!--                    </el-popover>-->
                  </div>
                </div>
              </div>
              <ul class="list light-color-3">
                <li class="list-title">1 conversation = 1 inquiry + 1 answer</li>
                <li class="list-item" v-for="(listItem,listIndex) in models" :key="listIndex">
                  {{ `${listItem.modelName} consumes ${listItem.tokenCost} quota each time` }}
                </li>
              </ul>
            </div>
            <div slot="reference" class="quota-l">
              <span class="quota-label">Quota balance</span>
              <span class="quota-count">54</span>
            </div>
          </el-popover>
          <div class="quota-r">
            <el-button class="quota-add" size="mini" icon="el-icon-plus" @click="openBuyDrawer"></el-button>
          </div>
        </div>
      </div>
      <template v-else>
        <!-- 标题 -->
        <div class="header-title white">{{ messageList[0]?.text }}</div>
      </template>

      <!-- 模型-->
      <div class="header-model">
        <img class="header-model-icon" :src="`${$g.imgPrefix}/img/shareAI/model.svg`">
        <div class="header-model-name">{{ filterObj(models, 'modelCode', selectedModel).modelName }}</div>
      </div>
      <!--      <div class="header-model dark-5" @click="toggleTheme">-->
      <!--        <div class="white">{{ isDark ? 'Switch To Light' : 'Switch To Dark' }}</div>-->
      <!--      </div>-->
    </div>
    <!-- 对话区域-->
    <div class="messages" ref="messagesBox">
      <div v-for="(mItem, mIndex) in messageList" :key="mIndex"
           :class="['messages-item', {'uItem':mItem.role==='user'}]">
        <img v-if="mItem.role=='assistant'" class="messages-avatar" :src="`${$g.imgPrefix}/img/shareAI/model-logo.png`">
        <div :class="['messages-content', {'uContent':mItem.role=='user'}]">
          <!-- 深度思考部分 - 始终保持在DOM中 -->
<!--          :class="{'thinking-collapsed': !mItem.showConsider}"-->
<!--          &&hasDeepThinking==1-->
          <div v-if="mItem.role=='assistant'&&!isEmpty(mItem.reasoningContent)" :class="['messages-thinking',{'thinking-collapsed': !mItem.showConsider}]">
            <div class="thinking-header" @click="toggleConsider(mIndex)">
              <div class="thinking-title">
                <i class="el-icon-info-circle thinking-icon"></i>
                <span>深度思考过程</span>
              </div>
              <div class="thinking-toggle">
                <i :class="mItem.showConsider ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
            </div>

            <!-- 思考内容 - 通过CSS控制显示/隐藏 -->
            <div class="thinking-content white">
              {{ mItem.reasoningContent || '' }}
              <template v-if="mItem.isThinking">
              <span v-if="selectedModel.includes('img')||selectedModel.includes('image')"
                    v-loading="selectedModel.includes('img')||selectedModel.includes('image')"></span>
                <span v-else class="thinking-cursor"></span>
              </template>
            </div>
          </div>

          <!-- 最终回答 -->
          <div :class="['messages-text white', {'utext dark-6':mItem.role=='user'}]">
            <span v-if="mItem.role==='user'">{{ mItem.content }}</span>
            <template v-else>
              <!-- <VueMarkdown v-if="mItem.content"
                           class="vue-markdown"
                           :source="mItem.content"
                           :key="mItem.content"
                           :html="true"
                           :breaks="true"
                           :linkify="true"
                           :emoji="true"
                           :toc="true"/> -->
                           <VueMarkdown v-if="mItem.content"
                           class="vue-markdown"
                           :source="processMarkdownContent(mItem.content)"
                           :key="mItem.content + '-' + mIndex" 
                           :html="true"
                           :breaks="true"
                           :linkify="true"
                           :emoji="false"
                           :toc="true"
                           :highlight="false"
                           v-highlight
                           v-replace-images
                           :prerender="preRenderHook"/>               
            </template>
            <template v-if="mItem.isResponding">
              <span v-if="selectedModel.includes('img')||selectedModel.includes('image')"
                    v-loading="selectedModel.includes('img')||selectedModel.includes('image')"></span>
              <span v-else class="thinking-cursor"></span>
            </template>
          </div>

          <!-- 图片-->
          <!-- <div v-if="mItem.role=='assistant'&&!sendEnterFlag&&!isEmpty(mItem.img)" class="messages-picture">
            <el-image
            class="messages-picture-img"
            :src="mItem.img"
            :preview-src-list="[mItem.img]">
            </el-image>
            <i class="el-icon-download" @click="getFile(mItem.img,'图片')"></i>
          </div> -->

          <!-- 操作-->
          <div v-if="mItem.role=='assistant'&&!sendEnterFlag" class="messages-operate">
            <img v-clipboard:copy="getAIResponse(mItem)"
                 v-clipboard:success="onCopy"
                 v-clipboard:error="onError"
                 class="messages-operate-icon"
                 :src="`${$g.imgPrefix}/img/shareAI/copy-light.svg`">
            <img @click="reSendMessage(mIndex)"
                 class="messages-operate-icon"
                 :src="`${$g.imgPrefix}/img/shareAI/refresh-light.svg`">
          </div>
        </div>
      </div>
    </div>
    <!-- 发送消息-->
    <div class="send" @click.stop="textClick">
      <div class="send-box border dark-6">
        <div class="send-top">
          <!-- 联网查询-->
          <el-button round @click="changeInternet"
          :disabled="filterObj(models, 'modelCode', selectedModel).canNetwork==0"
          :class="['send-model mr-2',{'active': networkMode}]">
            <div class="send-model-item">
              <img class="send-icon" :src="`${$g.imgPrefix}/img/shareAI/earth-light.svg`">
              <div>Search</div>
            </div>
          </el-button>
          
          <!-- 选择模型-->
          <div v-if="!isEmpty(models)" class="send-select">
           
            <el-dropdown trigger="click" @command="handleModels" placement="top">
              <!-- 选中的model-->
              <el-button class="send-model" round>
                <div class="send-model-item">
                  <div class="send-model-text">{{ filterObj(models, 'modelCode', selectedModel).modelName }}</div>
                  <i class="el-icon-sort el-icon--right"></i>
                </div>
              </el-button>
              <!-- model列表-->
              <el-dropdown-menu class="dark-1 send-dropmenu" slot="dropdown">
                <el-dropdown-item
                    v-for="mItem in models"
                    :key="mItem.modelCode"
                    :command="mItem.modelCode"
                    :class="[selectedModel===mItem.modelCode?'active':'light-color-3']">
                  {{ mItem.modelName }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            
          </div>
        </div>
        <div class="send-input-top">
          <el-tag
              v-for="tag in tags"
              :key="tag.name"
              closable
              @close="handleClosetag(tag)"
              :type="tag.type">
              {{tag.name}}
          </el-tag>
        </div>
        <div class="send-input">
          <!-- 上传文件 -->
          <el-upload
              class="avatar-uploader"
              :disabled="filterObj(models,'modelCode',selectedModel).canUpload==0"
              :action="uploadForm.url"
              :accept="uploadForm.acceptType"
              :file-list="uploadForm.fileList"
              multiple
              :limit="uploadForm.limit"
              :show-file-list="false"
              :http-request="uploadFile"
              :on-success="successHandle">
            <el-popover
                popper-class="upload-popper"
                :visible-arrow="false"
                placement="top"
                width="200"
                trigger="hover">
              <div class="content">
                <div class="content-title">Upload files</div>
                <div class="content-text">Support all kinds of documents and picture,up to 20,each 20MB</div>
              </div>
              <img slot="reference" class="send-upload" src="https://static.gamsgocdn.com/gg2/images/gamsai/attachment-B5BAC1.svg">
            </el-popover>
          </el-upload>


          <!-- 文本域-->
          <div class="send-input-box">
            <div class="file">

            </div>
            <!-- @keydown.enter="handleEnter"
            @compositionstart="isComposing = true"
            @compositionend="onCompositionEnd" -->
             <textarea
                 ref="messageInput"
                 v-model="inputText"
                 class="send-textarea"
                 :disabled="sendEnterFlag"
                 :placeholder="`Send Message To ${filterObj(models, 'modelCode', selectedModel).modelName} ...`"
                 @keydown="handleKeydown"
                 @compositionstart="handleCompositionStart"
                 @compositionend="handleCompositionEnd"
             ></textarea>
          </div>


          <!-- 发送按钮-->
          <div class="send-btn">
            <!-- 发送箭头-->
            <i v-if="!sendEnterFlag" class="el-icon-top" @click="handleEnter"></i>
            <!-- 停止发送-->
            <div v-else class="sending-btn" @click="stopEnter"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  filterObj,
  MessageError,
  MessageSuccess,
  isEmpty,
  formatObj,
  downLoadFile
} from "@/util/util";
import {
  stopStream,
  getUserActiveSubscription
} from '@/request/requests';
// import VueMarkdown from 'vue-markdown';
import { axios } from '@/request/request.js'
export default {
  name: "chatPanel",
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    isDark: Boolean,
    screenWidth: Number,
    models:{
      type:Array,
      default: () => []
    }
  },
  components:{
    //VueMarkdown
  },
  watch: {
    compositionActive(newVal, oldVal) {
      if (oldVal === true && newVal === false && this.enterKeyPressed) {
        this.$nextTick(() => {
          this.enterKeyPressed = false;
          this.sendMessage();
        });
      }
    }
  },
  computed:{
    selectedModel:{
      get(){
        return this.$store.state.chat.selectedModel;
      },
      set(val){
        this.$store.commit('chat/SET_SELECTED_MODEL',val)
      }
    },
    networkMode:{
      get(){
        return this.$store.state.chat.networkMode;
      },
      set(val){
        this.$store.commit('chat/SET_NETWORK_MODE',val)
      }
    },
    conversationId(){
      return this.$store.state.chat.conversationId;
    },
    requestId(){
      return this.$store.state.chat.requestId;
    },
    img:{
      get(){
        return this.$store.state.chat.img;
      },
      set(val){
        this.$store.commit('chat/SET_IMG',val);
      }
    },
    upload:{
      get(){
        return this.$store.state.chat.upload;
      },
      set(val){
        this.$store.commit('chat/SET_UPLOAD',val);
      }
    },
    url:{
      get(){
        return this.$store.state.chat.url;
      },
      set(val){
        this.$store.commit('chat/SET_URL',val);
      }
    }
  },
  created() {
  // 重置url为空数组
  this.url = '';
  // 清空标签
  this.tags = [];
  // 重置上传状态
  this.upload = '0';
},
  data() {
    return {
      tags: [
        // {
        //   name: 'GPT-4o-mini',
        //   type: 'info'
        // },
        // {
        //   name: 'GPT-4o',
        //   type: 'info'
        // },

   
      ],
      compositionActive: false,
      enterKeyPressed: false,
      isComposing: false,  // 是否正在使用输入法
      lastEnterTime: 0,
      inputText: '',
      messageList: [],
      considerTimer: null,
      responseTimer: null,
      printSpeed: 50,
      freeQuota: {
        before: 3,
        after: 5
      },
      paidQuota: {
        subscription: 0,
        extra: 50
      },
      //是否点击了发送消息按钮
      sendEnterFlag:false,
      scrollSpeed:400,
      quotaData:{
        //已使用的免费额度 = 免费额度 - 已使用的免费额度
        usedFreeCount:0,
        //免费额度
        freeTokenLimit:0,
        //付费额度
        paidQuota:0,
        //--------暂时没有--------
        subscription:0,
        extra:0
      },
      uploadForm:{
        url:'/chat/uploadFile',
        acceptType: 'image/*,.pdf,.doc,.docx,.dot,.xlsx,.xls',
        fileList: [],
        limit:20,
        fileSize: 512
      }
    }
  },
  methods: {
    filterObj,
    isEmpty,
    formatObj,
    downLoadFile,
    textClick(){
      this.$refs['messageInput'].focus();
    },
    // 自定义 渲染的图片下载功能
    // getFile(url, name) {
    //   this.downLoadFile(url, name);
    // },
   // 处理markdown内容
  processMarkdownContent(content) {
    if (!content) return '';

     // 简化的图片URL正则表达式
  const imgRegex = /https?:\/\/[^\s'"()<>]+\.(png|jpg|jpeg|gif|bmp|webp|svg)(\?[^\s'"()<>]*)?/gi;
  
  // 预处理文本
  const fixedText = content.replace(/https\s*:\/\//g, 'https://');
  
  // 将图片URL转换为特殊标记
  let processedContent = fixedText.replace(imgRegex, (match) => {
    // 使用特殊标记，稍后会被替换为组件
    return `<img-placeholder data-src="${match}"></img-placeholder>`;
  });
    
    // 确保未包装的代码块被正确格式化
    // 识别看起来像代码但没有被```包装的内容
    const codeDetectRegex = /^(const|let|var|import|function|class|if|for|while|{)[ \t]/gm;
     processedContent = processedContent.replace(codeDetectRegex, (match) => {
      // 检查这行是否已经在代码块内
      const lines = processedContent.split('\n');
      const lineIndex = lines.findIndex(line => line.includes(match));
      
      // 检查前面的行是否已经有```
      let isInCodeBlock = false;
      for (let i = lineIndex - 1; i >= 0; i--) {
        if (lines[i].trim() === '```' || lines[i].trim().startsWith('```')) {
          isInCodeBlock = true;
          break;
        }
        if (lines[i].trim() === '```' && i > 0 && lines[i-1].trim() === '```') {
          isInCodeBlock = false;
          break;
        }
      }
				// console.log("TCL: processMarkdownContent -> isInCodeBlock1", isInCodeBlock)
      
      if (!isInCodeBlock) {
        // 在这一行前面插入```javascript
        lines.splice(lineIndex, 0, '```javascript');
        // 找到代码块的结束并添加```
        let endFound = false;
        for (let i = lineIndex + 2; i < lines.length; i++) {
          if (lines[i].trim() === '' && i < lines.length - 1 && !lines[i+1].trim().match(codeDetectRegex)) {
            lines.splice(i + 1, 0, '```');
            endFound = true;
            break;
          }
        }
					console.log("TCL: processMarkdownContent -> endFound", endFound)
        if (!endFound) {
          lines.push('```');
        }
        processedContent = lines.join('\n');
      }
      
      return match;
    });
     
  //   // 简化的图片URL正则表达式 - 避免嵌套量词和过多回溯
  //   const imgRegex = /https?:\/\/[^\s'"()<>]+\.(png|jpg|jpeg|gif|bmp|webp|svg)(\?[^\s'"()<>]*)?/gi;
    
  //   // 预处理：修复URL中可能存在的错误分隔
  //   const fixedText = content.replace(/https\s*:\/\//g, 'https://');
    
  //   // 替换图片链接
  //   processedContent = fixedText;
    
  //   // 使用更安全的替换方法，避免无限循环
  //   let match;
  //   let lastIndex = 0;
  //   let result = '';
    
  //   // 手动遍历匹配，而不是使用replace
  //   imgRegex.lastIndex = 0; // 重置正则索引
  //   while ((match = imgRegex.exec(fixedText)) !== null) {
  //     // 添加匹配前的内容
  //     result += fixedText.substring(lastIndex, match.index);
  //     // 添加替换后的图片语法
  //     // result += `![图片](${match[0]})`;
  //     result +=`<div class="inline-image-container">
  //    <img src="${match[0]}" onclick="window.open('${match[0]}', '_blank')" class="markdown-image"/>
  //    <i class="el-icon-download" onclick="window.location.href='${match[0]}'; return false;" style="cursor:pointer;margin-left:10px;"></i>
  //  </div>`;
  //     // 更新处理位置
  //     lastIndex = match.index + match[0].length;
      
  //     // 安全措施：防止卡在同一位置
  //     if (match.index === imgRegex.lastIndex) {
  //       imgRegex.lastIndex++;
  //     }
  //   }
    
  //   // 添加剩余内容
  //   result += fixedText.substring(lastIndex);
  //   processedContent = result;
    
  //   console.log("TCL: processMarkdownContent -> ", processedContent)
    return processedContent;
  },
    // 可选：预渲染钩子
    preRenderHook(markdown) {
      // 这里可以添加更高级的处理逻辑
      return markdown;
    },
    handleClosetag(tag){
      this.tags.splice(this.tags.indexOf(tag), 1);
      this.url.splice(this.url.indexOf(tag.url), 1);
      if(this.url.length==0){
        this.upload = '0';
      }
			// console.log("TCL: handleClosetag -> this.url", this.url)
      // console.log("this.$store.state.chat.url",this.$store.state.chat.url)
    },
    uploadFile(params){
      console.log(params);
      const _file = params.file;
      const _type = params.file.type;
      const _suffix = params.file.name.split(".")[1];
      // const _size
      if (!(this.uploadForm.acceptType.indexOf(_type.split("/")[0]) > -1 || this.uploadForm.acceptType.indexOf(_suffix) > -1)) {
        // MessageError('请上传正确格式的文件');
        MessageError('Please upload a file in the correct format');
        params.onError();
        return false;
      }

      const formData = new FormData();
      formData.append('file', _file);
      const canNetwork = this.filterObj(this.models, 'modelCode', this.selectedModel).canNetwork;
      console.log(canNetwork)
      if(canNetwork==1){
        formData.append("canNetwork ",canNetwork);
      }
      // 上传文件
      axios.post(this.uploadForm.url,formData,{
        timeout: 300000,
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(res=>{
        // console.log(res)
        if(res.status==='200'){
          params.onSuccess(res);
        }
      })
    },
    successHandle(res,file,fileList){
			// console.log("TCL: successHandle -> fileList", fileList)
			// console.log("TCL: successHandle -> file", file)
      console.log('-------successHandle--------');
      // console.log(res)
      if(res.status=='200'){
        const size = (file.size/1024/1024).toFixed(3);
        const name = res.data?.filename +' ('+size+'MB)';
        this.upload = '1';
        this.url = res.data?.url;
        this.tags.push({
            name: name,
            type: 'info',
            url: res.data?.url
        });
        // console.log("this.$store.state.chat.url",this.$store.state.chat.url)
        // this.sendMessage();
        //this.$set(this.uploadForm,'fileList',fileList);
        //console.log(this.uploadForm.fileList);
      }
    },
    setMessageList(messageList){
      this.messageList = [];
      this.messageList = messageList;
      this.scrollToBottom();
    },
    reset(){
      this.messageList = [];
    },
    getFile(url,name){
       this.downLoadFile(url,name);
    },
    openBuyDrawer() {
      this.$emit('initBuyNowPhone');
    },
    clickFolder() {
      this.$emit('clickFolder');
    },
    handleModels(command) {
      this.selectedModel = command;
      //是否有深度思考   hasDeepThinking 0:无 1:有
      //this.hasDeepThinking = this.filterObj(this.models,'modelCode',this.selectedModel).hasDeepThinking;
      this.scrollToBottom();
    },
    changeInternet(){
      // 原根据model动态变化
      // let modelObj = this.filterObj(this.models,'modelCode',this.selectedModel);
      // this.$set(modelObj,'canNetwork',!modelObj.canNetwork);
      // 新根据networkMode状态变化 
      const flag =this.networkMode;
      this.networkMode = !flag;
    },
    getAIResponse(aItem) {
      return `${aItem?.reasoningContent || ''} ${aItem?.content || ''}`;
    },
    onCopy() {
      MessageSuccess(this.$t('friends.copysuccessfully'));
      // console.log('copy Success:' + e.text);
    },
    onError() {
      MessageError(this.$t('friends.copyfailed'));
      // console.log('copy Failed:' + e.text);
    },
    toggleTheme() {
      this.$emit('toggle-theme');
    },
    // 切换显示/隐藏深度思考
    toggleConsider(index) {
      if (this.messageList && this.messageList[index]) {
        this.$set(this.messageList[index], 'showConsider', !this.messageList[index].showConsider);
      }
    },
    async reSendMessage(index) {
      this.sendEnterFlag = true;
      if (this.messageList && this.messageList[index - 1]) {
        let message = this.messageList[index - 1].content;
        try {
          // 重置AI回复
          // if (this.messageList[index]) {
          //   this.$set(this.messageList[index], 'reasoningContent', '');
          //   this.$set(this.messageList[index], 'content', '');
          //   this.$set(this.messageList[index], 'isThinking', true); // 开始思考
          //   this.$set(this.messageList[index], 'isResponding', false);
          //   this.$set(this.messageList[index], 'showConsider', true); // 默认显示思考过程
          // }

          // 发送消息
          await this.$store.dispatch('chat/sendMessage', message);
          this.sendEnterFlag = false;
        } catch (error) {
          MessageError(error.data);
        }
      }
    },
    async stopEnter(){
      let params = {
        requestId: this.requestId
      }
      await stopStream(this.$qs.stringify(params));
      this.sendEnterFlag = false;
    },
    handleEnter(e) {
      // 检查输入框是否为空，如果为空且没有上传文件则直接返回
      if(this.isEmpty(this.inputText) && this.upload !== '1') {
        return;
      }
      
      // 如果正在使用输入法，不处理回车事件
      if (this.isComposing) {
        // 记录按下了回车键，等输入法结束后处理
        this.enterKeyPressed = true;
        return;
      }
      
      // 记录当前时间
      const now = Date.now();
      
      // 如果不是按下 shift + enter（换行）
      if (!e.shiftKey) {
        e.preventDefault(); // 阻止默认换行
        
        // 防止重复触发（某些浏览器可能触发多次）
        if (now - this.lastEnterTime > 300) {
          this.lastEnterTime = now;
          this.sendEnterFlag = true; // 设置发送标志
          this.safeSendMessage();
        }
      }
    },
    //旧方法舍弃， 存在可以发送空格，输入法未结束的时候发送
    // onCompositionEnd() {
    //   // 延迟设置，确保 v-model 已更新
    //   setTimeout(() => {
    //     this.isComposing = false;
        
    //     // 如果在输入法编辑过程中按下了回车，现在处理它
    //     if (this.enterKeyPressed) {
    //       this.enterKeyPressed = false;
          
    //       // 确保输入框不为空
    //       if (!this.isEmpty(this.inputText) || this.upload === '1') {
    //         this.sendEnterFlag = true;
    //         this.safeSendMessage();
    //       }
    //     }
    //   }, 100); // 增加延迟，确保输入法完全结束
    // },
    // safeSendMessage() {
    //   // 再次检查输入框是否为空
    //   if (this.isEmpty(this.inputText) && this.upload !== '1') {
    //     this.sendEnterFlag = false;
    //     return;
    //   }
      
    //   // 确保不在输入法编辑状态
    //   if (!this.isComposing) {
    //     this.sendMessage();
    //   } else {
    //     // 如果在输入法编辑状态，等待编辑完成后再发送
    //     const checkComposition = setInterval(() => {
    //       if (!this.isComposing) {
    //         clearInterval(checkComposition);
            
    //         // 再次检查输入框是否为空
    //         if (!this.isEmpty(this.inputText) || this.upload === '1') {
    //           this.sendMessage();
    //         } else {
    //           this.sendEnterFlag = false;
    //         }
    //       }
    //     }, 100);
        
    //     // 设置超时，防止无限等待
    //     setTimeout(() => {
    //       clearInterval(checkComposition);
    //       if (this.isComposing) {
    //         this.isComposing = false;
    //         // 最后一次检查输入框是否为空
    //         if (!this.isEmpty(this.inputText) || this.upload === '1') {
    //           this.sendMessage();
    //         } else {
    //           this.sendEnterFlag = false;
    //         }
    //       }
    //     }, 2000);
    //   }
    // },
    async sendMessage() {
      // 检查输入是否有效
				// console.log("TCL: sendMessage -> this.upload", this.upload)
      if ((this.inputText && this.inputText.trim()) || (this.upload=='1')) {
        const messageToSend = this.inputText.trim();
        // console.log("messageToSend",this.inputText.trim())
       
        // 不清空已有的消息列表，只是确保它已初始化
        if (!this.messageList) {
          this.messageList = [];
        }
        
        let messageai = messageToSend;
        console.log('sendMessage')
        // 将用户消息添加到消息列表
        //上传文件
        if(this.upload=='1'){
          // 不需要拼接，因为不同model 分析文件的构造不一样
          // messageai = messageToSend+this.url 
          this.messageList.push({
            role:'user',
            content:messageToSend+this.url
          });
        }else{
          this.messageList.push({
            role:'user',
            content:messageToSend
          });
        }


        // messsageList 向下追加 （影响聊天框的数据）
        this.messageList.push({
          role: 'assistant',
          reasoningContent: '',
          content: '',
          img:'',
          isThinking: true,
          isResponding: true,
          showConsider: true,
        });

        // 清空输入框 初始化文件 url 以及tag
        this.inputText = '';
        this.img = '';
        this.tags = [];

        try {
          // 发送消息
          await this.$store.dispatch('chat/sendMessage', messageai);

          //刷新左侧列表
          if(this.$store.state.chat.isRefresh){
            this.$emit('get-conversations',true)
            console.log("TCL: sendMessage -> 刷新左侧列表")
          }
          let res = await getUserActiveSubscription();
          if(res.status == '200'){
            let data = res.data;
            if(!this.isEmpty(data)){
							let quotaData = {
								freeTokenLimit: data.freeTokenLimit,
								usedFreeCount: data.freeTokenLimit - data.usedFreeCount,
								paidQuota: data.paidQuota
							}
              this.$store.commit('chat/SET_QUOTA_DATA', quotaData);							
            }
          }
          this.scrollToBottom();
          this.$nextTick(() => {
            // 消息发送后聚焦输入框
            this.$refs.messageInput.focus();
            this.sendEnterFlag = false;
          });
        } catch (error) {
          this.sendEnterFlag = false;
          //清空上传文件返回的文件路径
          this.url = '';
          this.upload = '0';
          console.error('发送消息出错:', error);
          // MessageError(error.data || '发送消息失败')
          MessageError(error.data || 'Failed to send message')
        }
      }else{
        this.sendEnterFlag = false;
      }
    },
    scrollToBottom() {
      this.$nextTick(()=>{
        let scrollElem = this.$refs.messagesBox;
        if(scrollElem){
          scrollElem.scrollTo({
            top: scrollElem.scrollHeight,
            behavior:'smooth'
          })
        }
      })
    },
    // 处理流式深度思考响应
    handleConsiderUpdate(content) {

      if (!this.messageList || this.messageList.length === 0) return;

      const lastIndex = this.messageList.length - 1;
      const lastMessage = this.messageList[lastIndex];

      if (lastMessage && lastMessage.role === 'assistant') {
        this.$set(lastMessage, 'reasoningContent', content);
        this.$set(lastMessage, 'isThinking', content.length === 0 ? false : true);

        // 自动滚动
        //setTimeout(()=>{
          this.scrollToBottom();
       // },this.scrollSpeed)
      }
    },
    // 处理流式最终回答响应
    handleResponseUpdate(content) {
      // console.log('处理回答更新, 内容长度:', content.length, '内容:', content.substring(0, 20) + '...');
      // console.log('当前消息列表长度:', this.messageList ? this.messageList.length : 0);
      
      if (!this.messageList || this.messageList.length === 0) {
        // console.log('消息列表为空，无法更新');
        return;
      }

      const lastIndex = this.messageList.length - 1;
      const lastMessage = this.messageList[lastIndex];
      
      // console.log('最后一条消息:', lastMessage ? `角色=${lastMessage.role}, 内容长度=${(lastMessage.content || '').length}` : '无消息');

      if (lastMessage && lastMessage.role === 'assistant') {
        this.$set(lastMessage, 'content', content);
        this.$set(lastMessage, 'isResponding', content.length === 0 ? false : true);
        this.$set(lastMessage,'img',this.img);
        // 如果思考已完成且回答开始，自动收起思考
        if (content.length > 0 && !lastMessage.isThinking) {
          this.$set(lastMessage, 'showConsider', false);
        }
        // 自动滚动
        this.scrollToBottom();
      } else {
        console.log('警告: 最后一条消息不是AI消息，可能导致流式输出不显示');
        // 尝试查找任何一条AI消息
        const aiMessage = this.messageList.find(msg => msg.role === 'assistant');
        if (aiMessage) {
          console.log('找到一条AI消息，使用它更新内容');
          this.$set(aiMessage, 'content', content);
          this.$set(aiMessage, 'isResponding', true);
          
          // 自动滚动
         // setTimeout(()=>{
            this.scrollToBottom();
          //},this.scrollSpeed)
        } else {
          console.log('未找到任何AI消息，需要创建新的');
          // 创建一个新的AI消息
          this.messageList.push({
            role: 'assistant',
            reasoningContent: '',
            content: content,
            img:'',
            downloadimg:'',
            isThinking: false,
            isResponding: true,
            showConsider: false,
          });
          
          // 自动滚动
          //setTimeout(()=>{
            this.scrollToBottom();
          //},this.scrollSpeed)
        }
      }
    },
    // 新增方法，处理按键
    handleKeydown(e) {
      // 回车键
      if (e.keyCode === 13) {
        // 如果是Shift+Enter不处理，允许换行
        if (e.shiftKey) {
          return;
        }
        
        // 阻止默认行为
        e.preventDefault();
        
        // 如果正在使用输入法，只记录回车按下状态，不执行发送
        if (this.isComposing) {
          this.enterKeyPressed = true;
          return;
        }
        
        // 检查防抖并发送
        const now = Date.now();
        if (now - this.lastEnterTime > 300 && (!this.isEmpty(this.inputText) || this.upload === '1')) {
          this.lastEnterTime = now;
          this.sendEnterFlag = true;
          this.safeSendMessage();
        }
      }
    },
    
    // 修改输入法开始事件处理
    handleCompositionStart() {
      // console.log('输入法开始');
      this.isComposing = true;
    },
    
    // 修改输入法结束事件处理
    handleCompositionEnd() {
      // console.log('输入法结束');
      // 使用更长的延迟确保输入法完成
      setTimeout(() => {
        this.isComposing = false;
        // console.log('输入法结束后的状态:', this.enterKeyPressed);
        
        // 如果在输入法输入过程中按了回车，现在处理它
        if (this.enterKeyPressed) {
          this.enterKeyPressed = false;
          if (!this.isEmpty(this.inputText) || this.upload === '1') {
            // console.log('延迟执行发送');
            this.sendEnterFlag = true;
            this.safeSendMessage();
          }
        }
      }, 200); // 使用更长的延迟
    },
    
    // 修改安全发送方法
    safeSendMessage() {
      // console.log('尝试安全发送, 当前输入法状态:', this.isComposing);
      
      // 再次检查输入框是否为空
      if (this.isEmpty(this.inputText) && this.upload !== '1') {
        this.sendEnterFlag = false;
        return;
      }
      
      // 如果仍在输入法编辑状态，等待完成
      if (this.isComposing) {
        // console.log('输入法编辑中，延迟发送');
        // 设置一个定时器等待输入法完成
        const checkComposition = setInterval(() => {
          // console.log('检查输入法状态:', this.isComposing);
          if (!this.isComposing) {
            clearInterval(checkComposition);
            // console.log('输入法已完成，现在发送');
            this.sendMessage();
          }
        }, 100);
        
        // 设置超时，防止无限等待
        setTimeout(() => {
          clearInterval(checkComposition);
          if (this.isComposing) {
            console.log('输入法超时，强制完成');
            this.isComposing = false;
            this.sendMessage();
          }
        }, 3000); // 增加超时时间
      } else {
        // 不在输入法状态，直接发送
        console.log('直接发送');
        this.sendMessage();
      }
    },
  },
  mounted() {
    // 订阅store的变化
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'chat/UPDATE_STREAMING_CONSIDER') {
        //console.log("深度思考内容更新")
        // 深度思考内容更新
        this.handleConsiderUpdate(state.chat.streamingConsider);
      } else if (mutation.type === 'chat/UPDATE_STREAMING_RESPONSE') {
        //console.log("最终回答更新")
        // 最终回答更新
        this.handleResponseUpdate(state.chat.streamingResponse);
      } else if (mutation.type === 'chat/END_STREAMING') {
        //console.log("流结束时")
        // 流结束时，更新状态
        if (this.messageList && this.messageList.length > 0) {
          const lastMessage = this.messageList[this.messageList.length - 1];
          //console.log(lastMessage)
          if (lastMessage && lastMessage.role === 'assistant') {
            this.$set(lastMessage, 'isThinking', false);
            this.$set(lastMessage, 'isResponding', false);
          }
          //清空上传文件返回的文件路径
          this.url = '';
          this.upload = '0';
          this.scrollToBottom();
        }
      } else if (mutation.type === 'chat/SEND_MESSAGE') {
        //console.log('用户消息已发送到store');
      } else if (mutation.type === 'chat/START_STREAMING') {
        //console.log('开始流式传输');
      }
    });
  },
  beforeDestroy() {
    if (this.considerTimer) {
      clearInterval(this.considerTimer);
    }
    if (this.responseTimer) {
      clearInterval(this.responseTimer);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/shareAI.scss";
</style>
<style lang="scss">
@import "~@/assets/css/variables.scss";
.quota-popper {
  background: #232428;
  border-radius: 8px;
  border: none;
  padding: 16px;
  left: 53px !important;

  &-title {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin-bottom: 16px;
  }

  .info {
    margin-bottom: 16px;

    &-item {
      display: flex;
      align-items: baseline;

      &:not(:last-child) {
        margin-bottom: 8px;
      }

      &-label {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        font-family: Gilroy, FB;
      }

      &-count {
        font-size: 12px;
        font-weight: 700;
        letter-spacing: -.14px;
        line-height: 16px;
      }

      &-value {
        font-family: Gilroy, FB;

        &.before {
          color: #74aa9c;
        }
      }

      &-paid-count {
        font-size: 12px;
        font-weight: 700;
        letter-spacing: -.14px;
        line-height: 16px;
        font-family: Gilroy, FB;
        display: flex;

        .el-icon-warning {
          cursor: pointer;
          margin-left: 3px;

          &::before {
            color: #4E5159;
            font-size: 17px;
          }
        }
      }
    }
  }

  .list {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    font-family: Gilroy, FB;

    &-title {
      margin-bottom: 8px;
    }

    &-item {
      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }

}

.paid-popper {
  border: 1px solid #383940;
  background: #232428;

  .popper__arrow {
    display: none;
  }

  .list {
    .item {
      display: flex;
      align-items: baseline;
      margin-bottom: 10px;
      font-size: 13px !important;
    }

    .count {
      margin-left: 5px;
      font-weight: bold;
      font-family: Gilroy, FB;
    }
  }
}

.upload-popper{
  background: #232428;
  border:none;
  color:#ffffff;
  font-size:12px;
}

.send-dropmenu.el-dropdown-menu{
  border:none;
  max-height: calc(80vh - 60px - 153px);
  overflow-y: auto;
  .popper__arrow{
    display:none;
  }
  .active{
    color: #69e1a5;
  }
  .el-dropdown-menu__item{
    &:hover, &:focus{
      background-color:transparent;
    }
  }
}
</style>

